export default "__VITE_ASSET__07942ee7__"